var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',_vm._b({model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},'Modal',_vm.$attrs,false),[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._t("header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }